export const FIX_RECTANGLES = "FIX_RECTANGLES";
export const IS_DRAWING = "IS_DRAWING";
export const CORRECTION_POLYGON = "CORRECTION_POLYGON";
export const UPDATE_RECTANGLE = "UPDATE_RECTANGLE";
export const UNDO_POLYGON = "UNDO_POLYGON";
export const RESET_DRAW_POLYGON = "RESET_DRAW_POLYGON";